module.exports = __webpack_public_path__ + "fonts/Roboto-Medium.0693bf1.eot";